<div class="block w-full rounded-2xl py-4 md:p-10 transition-all">
  <div
    class="text-center p-6 bg-white border-t-4 border-t-green-500 rounded-xl shadow-sm m-auto font-sans w-fit min-w-full md:min-w-2xl"
  >
    <div class="text-4xl mb-4">✅</div>
    <h2 class="text-slate-900">Submitted</h2>
    <p class="font-bold text-slate-500 mt-2 text-xl">
      <hsuc-safe-script
        [scriptCode]="renderStore.renderPayload().endStatePayload?.endMessage"
      ></hsuc-safe-script>
    </p>

    <div
      class="flex justify-between items-center mt-4 pt-4 border-t border-slate-100"
    >
      <div>
        @if(true) {
        <button
          (click)="goBack()"
          class="flex items-center justify-center p-2 rounded-full text-slate-500 hover:bg-slate-100 transition-colors duration-200 focus:outline-none"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="2.5"
            stroke="currentColor"
            class="w-5 h-5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15.75 19.5L8.25 12l7.5-7.5"
            />
          </svg>
        </button>
        }
      </div>
    </div>
  </div>
</div>
